import React from "react";
const ErrorMessage = ({ children }) => {
  return (
      <h4>{children}</h4>
  );
};

export default ErrorMessage;